<template>
    <header class="navbar" v-if="!$parent.isAdminPage($route.path, $route.name)">
        <div class="container-fluid">
            <button class="navbar-toggler mobile-toggler hidden-lg-up" type="button">☰</button>
            <router-link to="/retailer-execution" exact class="navbar-brand" style="padding:0; text-align: center;background-image: none;" >
                <span v-if="!logo">{{ company_name }}</span>
                <img v-else class="logo" v-bind:src="logo">
            </router-link>
            <ul class="nav navbar-nav hidden-md-down float-xs-left">
                <li class="nav-item" style="display:none;">
                    <a class="nav-link navbar-toggler layout-toggler"  href="#">☰</a>
                </li>
                <li class="nav-item" style="padding: 0 20px;padding-left:40px;" v-if="is_master === true || (is_manager === true || is_client === true)">
                    <router-link :to="{path: '/retailer-execution', query: { page: 1 }}" class="nav-link" :class="{'active ': is_active_menu('retail execution')}"  exact >
                        Retail Execution
                    </router-link>
                </li>
                <li class="nav-item" style="padding: 0 20px;"  v-if="is_master === true || ((is_manager === true || is_client === true) && (company_plan === 2 || company_plan === 3 || company_plan === 4))">
                    <router-link to="/stock-management-dashboard" exact class="nav-link" :class="{'active ': is_active_menu('stock-management-dashboard')}"  >
                        &nbsp;&nbsp;Stock Management
                    </router-link>
                </li>
                <li class="nav-item" style="padding: 0 20px;"  v-if="is_master === true || ((is_manager === true || is_client === true) && company_plan === 4)">
                    <router-link :class="{'active ': is_active_menu('sales dashboard')}" class="nav-link" :to="{path: '/sales-dashboard', query: { page: 1 }}" exact >
                        Sales
                    </router-link>
                </li>
            </ul>
            <ul class="nav navbar-nav float-xs-right">
                <li class="nav-item dropdown">
                    <router-link v-if="is_master === true || is_manager === true" :to="{path: '/settings', }" exact style="float:left;" class="nav-link avatar">
                        <i class="icon-settings icons font-2xl" style="color: #25bdad;"></i>
                    </router-link>
                    <a style="float:left;"  class="nav-link avatar" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
                        <!-- <img src="/static/img/avatars/6.jpg" class="img-avatar" alt="admin@bootstrapmaster.com"> -->
                        <i class="icon-user icons font-2xl" style="color: #25bdad;"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                        <router-link :to="{path: '/profile', }" exact class="dropdown-item">
                            <i class="fa fa-user"></i> Profile
                        </router-link>
                        <router-link :to="{path: '/settings', }" exact class="dropdown-item" v-if="is_master === true || permissions.indexOf('1') >= 0">
                            <i class="fa fa-wrench"></i> Settings
                        </router-link>
                        <a class="dropdown-item" href="#" v-on:click.prevent="logout"><i class="fa fa-lock"></i> Logout</a>
                    </div>
                </li>
            </ul>
        </div>
    </header>
</template>

<script>
  import _ from 'lodash'
  export default {
    data () {
      return {
        permissions: (this.$cookies.isKey('om_session_permissions')) ? this.$cookies.get('om_session_permissions').split(',') : [],
        logo: '',
        company_name: 'The Company Name',
        roles: (this.$cookies.isKey('om_session_roles')) ? JSON.parse(this.$cookies.get('om_session_roles')) : [],
        is_manager: false,
        is_merchandiser: false,
        is_client: false,
        is_promoter: false,
        company_plan: '',
        is_master: false
      }
    },
    created () {
      var company = (this.$cookies.isKey('om_session_company')) ? JSON.parse(this.$cookies.get('om_session_company')) : []
      if (Object.keys(company).length) {
        this.company_name = company.name
        this.logo = company.logo
        this.company_plan = (company) ? parseInt(company.plan_id) : null
      }
      var vue = this
      _.each(this.roles, function (item) {
        if (item.name === 'manager') {
          vue.is_manager = true
        }
        if (item.name === 'supervisor') {
          vue.is_manager = true
          vue.is_master = true
        }
        if (item.name === 'merchandiser') {
          vue.is_merchandiser = true
        }
        if (item.name === 'client') {
          vue.is_client = true
        }
        if (item.name === 'promoter') {
          vue.is_promoter = true
        }
        if (item.name === 'Sales Manager' || item.name === 'Sales and Data Controller' || item.name === 'Data Admin') {
          vue.is_master = true
        }
      })
      console.log(this.is_manager)
    },
    methods: {
      logout: function (event) {
        this.$http.post(process.env.API_ENDPOINT + '/user/logout?token=' + this.$cookies.get('om_session')).then((response) => {
          // response
        }, (response) => {
          // fail
        })

        this.$cookies.remove('om_session')
        this.$cookies.remove('om_session_info')
        this.$cookies.remove('om_session_company')
        this.$cookies.remove('om_session_permissions')
        this.$cookies.remove('om_session_roles')
        this.$cookies.remove('om_session_last')
        this.$cookies.remove('current_menu')
        this.$router.go('/login')
      },
      is_active_menu: function (menu) {
        if (this.$cookies.get('current_menu') == menu) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Header.vue?b58b56d6